import http from 'services/http';

// Mirrors the JobProcess statuses the backend serializes and broadcasts. The UI maps
// pending|running -> processing, completed -> success, error -> failure.
export type HighCostMedicationListImportStatus = 'pending' | 'running' | 'completed' | 'error';

export interface HighCostMedicationListImport {
  id: string;
  status: HighCostMedicationListImportStatus;
  // Human-readable failure message (PHI-free), shown as the failure notification's detail line.
  error: string | null;
  filename: string | null;
}

export interface CreateHighCostMedicationListImportParams {
  clientId: string;
  signedId: string;
  filename: string;
}

export async function createHighCostMedicationListImport(
  params: CreateHighCostMedicationListImportParams
): Promise<HighCostMedicationListImport> {
  return http
    .post<HighCostMedicationListImport>('/admin/high_cost_medication_list_imports', params)
    .then((response) => response.data);
}

export function isTerminalHighCostMedImportStatus(status: HighCostMedicationListImportStatus): boolean {
  return status === 'completed' || status === 'error';
}
